import React from "react";
import { EffectFade } from 'swiper';
import Swiper, { SwiperSlide } from "../../components/swiper";
import sliderData from "../../data/hero-sliders/hero-slider-nine.json";
import HeroSliderNineSingle from "../../components/hero-slider/HeroSliderNineSingle.js";

const params = {
  effect: "fade",
  fadeEffect: {
    crossFade: true
  },
  loop: true,
  speed: 1000,
  autoHeight: false,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false
  },
  watchSlidesVisibility: true,
  navigation: false,
};

const HeroSliderNine = ({ block }) => {

  return (
    <div
      className={`slider-area ${block.spaceLeftClass ? block.spaceLeftClass : ""} ${
        block.spaceRightClass ? block.spaceRightClass : ""
      }`}
    >
      <div className="slider-active nav-style-1">
        <Swiper options={params}>
          {block?.contentData?.map((single, key) => {
              return (
                <SwiperSlide key={key}>
                <HeroSliderNineSingle
                  data={single}
                  key={key}
                  sliderClass="swiper-slide"
                />
                </SwiperSlide>
              );
            })}
        </Swiper>
      </div>
    </div>
  );
};

export default HeroSliderNine;
